let connectionStringSetting = null;
let listeners = {};

function MessagingApi() {
  if (!connectionStringSetting) {
    const signalR = require("@microsoft/signalr"),
      start = function () {
        connectionStringSetting.start().catch((ex) => {
          console.log("conection error: " + ex);
          setTimeout(start, 5000);
        });
      };

    let logLevel = signalR.LogLevel.Trace;

    connectionStringSetting = new signalR.HubConnectionBuilder()
      .withUrl("/api/message")
      .configureLogging(logLevel)
      .withAutomaticReconnect()
      .build();

    connectionStringSetting.onreconnecting(function (ex) {
      console.log("onreconnecting: " + ex);
    });
    connectionStringSetting.onreconnected(function () {
      console.log("onreconnected");
    });

    connectionStringSetting.on("message", (data) => {
      for (const handlers of Object.values(listeners)) {
        for (const [eventName, handler] of Object.entries(handlers)) {
          if (eventName === data.eventName && handler) {
            handler(data.payload);
          }
        }
      }
    });

    start();
  }

  return <></>;
}

export async function getEvents(group, handlers) {
  if (listeners[group]) {
    for (const [eventName, handler] of Object.entries(handlers)) {
      listeners[group][eventName] = handler;
    }
  } else {
    listeners[group] = handlers;

    await fetch(`/api/message/addtogroup/${group}`);
  }
}

export async function stopEvents(group) {
  delete listeners[group];

  // await fetch(`/api/message/removefromgroup/${group}`);
}

export default MessagingApi;
